export const PACKAGE_VERSION = '1.12.0'
